import hasuSongs from '../../data/hasu-songs.json';

export const useHasuSongData = () => {
  return hasuSongs.data;
};
